import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import { reqIdleCallback, getUUID, assign, isObject, isInObjectInclude } from './utils';
import { isPromise } from './promise/index';

// 三方小程序APlus长度测试：
/*
1. GET、WS：ok
2. UT：4w
3. POST：连续调用会pending
4. sendBeacon：累计64KB限制，aplus现在没有做限制，存在风险
4. 小程序
    1. UT：淘宝iOS 4w、淘宝Android 4w
    2. GET：支付宝iOS 6w、支付宝Android 7000、小程序IDE 7000
5. 浏览器：
    1. Android Chrome GET：64928
    2. iOS safari GET：
6. SLS：3MB
*/
// 都走POST应该就不需要对小程序单独处理的
var CONFIG_MAX_URL_LIMIT = 'maxUrlLength';
// 必要参数的配置key
var CONFIG_REQUIREDFIELDS = 'requiredFields';
// const MINIAPP_LENGTH = 5000;
// const WEB_LENGTH = 35000;
// let URL_LIMIT = isInWindmillByMY() ? MINIAPP_LENGTH : WEB_LENGTH;
// const URL_LIMIT = 1*1024*1024; // SLS POST请求最大3MB，先限制1MB试试
var URL_LIMIT = 30000; // 保留10000给aplus自己的参数、gokey整体的encode
// SLS logs数量限制：4096
// const LOGS_COUNT_LIMIT = 4096;
// SDK版本，构建时动态更新
var SDK_VERSION = '3.3.9';
// 需要上报的全局维度白名单
// const TAGS_WHITE_LIST = [
//     // 主动设置
//     'pid', 'page_id', 'env', 'username', 'uid', 'user_type',
//     // 主动设置（可选）
//     'sid',
//     // 自动采集
//     'device_id',
//     'net_type', 'downlink',
//     'sdk_version',
//     'xreplay_id',
//     'origin_url', 'title', 'spm_a', 'spm_b',
//     'sr', 'dpi',
//     'pv_id',
//     'ua',
//     'device_model', 'device_brand',
//     // 小程序没有ua
//     'app_name', 'app_version', 'os', 'os_version'
// ];
/**
 * 缓存日志队列最大数量
 */
var MAX_REQ_QUEUE_LENGTH = 1000;

/**
 * 将变量转换成字符串
 * @method itemToString
 * @param {*} v
 * @returns {String}
 */
var itemToString = function itemToString(v) {
  var type = Object.prototype.toString.call(v);
  if (type === '[object String]' && v || type === '[object Number]' || type === '[object Boolean]') {
    return v;
  } else if (type === '[object Object]' || type === '[object Array]') {
    // 业务自定义参数可能存在循环引用，先忽略这样的参数
    try {
      return _JSON$stringify(v);
    } catch (ex) {}
  }
};
/**
 * 将对象中的每一个变量转换成字符串
 * @method toString
 * @param {*} obj
 * @returns
 */
var toString = function toString(obj) {
  var r = {};
  for (var i in obj) {
    var v = obj[i];
    if (v !== undefined) {
      r[i] = itemToString(v);
    }
  }
  return r;
};
/**
 * 将对象转换成查询字符串，要求对象的key必须不带特殊字符，AEM场景下不存在
 * @param {obj} 需要转换的对象
 */
var objToQS = function objToQS(obj) {
  var qs = [];
  for (var i in obj) {
    var v = itemToString(obj[i]);
    if (v !== undefined) {
      qs.push("".concat(i, "=").concat(encodeURIComponent(v)));
    }
  }
  return qs.join('&');
};

/**
 * 是否有必要参数没有设置好
 * @method isRequiredFieldNotReady
 * @params {Object} aes_config 当前的配置
 * @private
 */
function isRequiredFieldNotReady(aes_config) {
  // requiredField是否已经存在，pid、device_id默认为必要参数
  var requiredFields = (aes_config[CONFIG_REQUIREDFIELDS] || []).concat(['pid']);
  return requiredFields.some(function (field) {
    return aes_config[field] === undefined;
  });
}
/**
 * 打印日志解析错误
 */
function logParseErr() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var log = arguments.length > 1 ? arguments[1] : undefined;
  typeof console !== 'undefined' && console.warn("[AES] \u65E5\u5FD7\u89E3\u6790\u62A5\u9519\uFF0C\u57CB\u70B9\u5C06\u88AB\u4E22\u5F03 => ".concat(message), log);
}
function Core(aes_config) {
  this._queue = [];
  this._reqQueue = [];
  this._plugins = {};
  this._subscribers = {
    onConfigUpdated: []
  };
  this._config = {
    sdk_version: SDK_VERSION,
    pv_id: getUUID(),
    timezone_offset: new Date().getTimezoneOffset()
  };
  if (aes_config) {
    this._config = assign(this._config, aes_config);
  }
}
Core.prototype = {
  constructor: Core,
  /**
   * 发送队列中的所有埋点
   * @method _sendAll
   * @private
   */
  _sendAll: function _sendAll() {
    // if(this._queue.length){
    //     debugger
    // }
    if (!this._queue.length) {
      return;
    }
    // console.time('_sendAll')
    var limit = this._config[CONFIG_MAX_URL_LIMIT] || URL_LIMIT;
    var config = this._getSendConfig();

    // 如果整体长度OK，则一次能发送完
    var fullQS;
    // 如果_processData里报错了，则走到下面一条条追加的模式，排除掉队列里字段有问题的日志
    try {
      fullQS = this._processData(this._queue, config);
    } catch (ex) {}
    if (fullQS && fullQS.length < limit) {
      this._queue = [];
      this.send(fullQS);
      // console.timeEnd('_sendAll')
      return;
    }

    // 否则一条条追加测试
    // TODO：目前是一条条追加测试，大部分情况下是不是反过来效率更高？
    var logs = [];
    var body;
    while (this._queue.length) {
      // 从队列中拿出最早的一条日志放入logs中准备发送
      logs.push(this._queue.shift());
      // 防止因为埋点字段里的字符异常导致_processData里的encodeURIComponent报错，如果报错则单行解析上报
      try {
        body = this._processData(logs, config);
      } catch (ex) {
        // 解析失败的时候剔除刚添加的这一条日志，如果队列里还有日志，继续处理
        var ignoreItem = logs.pop();
        logParseErr(ex.message, ignoreItem);
        continue;
      }
      // 如果追加一条日志后长度超了，则回滚一条，然后结束循环然后上报
      if (body.length > limit) {
        // 如果logs里只有1条日志，则还是上报，否则将最后一条放回到队列中，递归再次上报
        if (logs.length > 1) {
          // 大于1条时，将最后一条放回到队列中，拿剔除最后一条的日志重新解析body并上报
          this._queue.unshift(logs.pop());
          // 追加的过程中已经try catch过，这里可以直接调用
          body = this._processData(logs, config);
        }
        break;
      }
    }
    // 存在body则上报
    body && this.send(body);
    // 如果队列中还存在未发送的日志，则递归调用
    if (this._queue.length) {
      this._sendAll();
    }
    // console.timeEnd('_sendAll')
  },
  /**
   * @method _send
   * @params data {Object} 需要发送的数据
   * @params data.logs {Array} 需要发送的样本列表
   * @params data.config {Object} 全局配置
   * @params [isCombo] {Boolean} 是否需要combo发送
   * @private
   */
  _send: function _send(data, isCombo) {
    if (isCombo === false) {
      // reqIdleCallback(()=>{
      var body;
      try {
        body = this._processData([data]);
      } catch (ex) {
        logParseErr(ex.message, data);
      }
      body && this.send(body);
      // })
    } else {
      this._queue.push(data);
      reqIdleCallback(this._sendAll.bind(this));
    }
  },
  /**
   * 获取需要上报的维度，并转换成字符串
   * @method _getSendConfig
   * @returns {Object}
   * @private
   */
  _getSendConfig: function _getSendConfig() {
    var config = {};
    var aes_config = this._config;
    for (var key in aes_config) {
      // 1. CONFIG_REQUIREDFIELDS、CONFIG_MAX_URL_LIMIT、debug不上报
      // 2. 插件配置不上报
      key !== CONFIG_REQUIREDFIELDS && key !== CONFIG_MAX_URL_LIMIT && key !== 'queueGlobalName' && key !== 'debug' && key.indexOf('plugin') !== 0 &&
      // (TAGS_WHITE_LIST.includes(key) || key.indexOf('dim') === 0) &&
      // 3. 空字符串、null、undefined不上报
      aes_config[key] !== '' && aes_config[key] !== null && aes_config[key] !== undefined && (config[key] = itemToString(aes_config[key]));
    }
    return config;
  },
  /**
   * 为埋点增加全局配置参数
   * @method _processData
   * @params logs {Array} 需要发送的日志列表
   * @return {String} 给到黄金令箭gokey的查询字符串
   * @private
   */
  _processData: function _processData(logs, config) {
    config = config || this._getSendConfig();
    var qs = objToQS(config);
    qs += '&msg=' + encodeURIComponent(logs.map(function (log) {
      // return encodeURIComponent(objToQS(log));
      return objToQS(log);
    }).join('|'));
    return qs;
  },
  /**
   * 修改全局配置
   *
   *      aes.setConfig(key, value)
   *      aes.setConfig({...})
   *
   * @method setConfig
   * @params key {String|Object} 参数名或者一组参数组成的对象
   * @params [value] {String|Number} 参数值
   */
  setConfig: function setConfig(key, value) {
    var _this = this;
    var newConfig = {};
    if (value !== undefined) {
      newConfig[key] = value;
    } else {
      newConfig = key;
    }
    var isConfigChanged = !isInObjectInclude(newConfig, this._config);
    var setConfig = function setConfig() {
      // 配置无变化，不做更新
      if (!isConfigChanged) {
        return;
      }
      for (var i in newConfig) {
        if (isObject(newConfig[i])) {
          _this._config[i] = assign(_this._config[i] || {}, newConfig[i]);
        } else {
          _this._config[i] = newConfig[i];
        }
      }
      // 设置为对象格式，第一个参数为对象，第二个参数 AES 对象的新配置
      _this._execSubscribe('onConfigUpdated', [newConfig, _this._config]);
    };
    // 有因为必要参数没有Ready而缓存的埋点时，先设置config，然后判断必要参数是否已经ready，如果ready就清空缓存的队列
    // 当存在这样的缓存队列时，所有埋点会携带最后的config信息发送
    if (this._reqQueue.length) {
      setConfig();
      if (
      // 当前配置项属于必要配置
      // requiredFields.indexOf(k) !== -1 &&
      // 必要配置都已经存在
      !isRequiredFieldNotReady(this._config)) {
        this._reqQueue.forEach(function (args) {
          _this._send.apply(_this, args);
        });
        this._reqQueue = [];
      }
      // 在Config变化前清空历史队列中的埋点，保证埋点发送时会携带最新的config配置
    } else {
      if (isConfigChanged) {
        this._sendAll();
      }
      setConfig();
    }
  },
  /**
   * 获取全局配置
   * @method getConfig
   * @params [key] {String} 参数key
   */
  getConfig: function getConfig(key) {
    return key ? this._config[key] : this._config;
  },
  /**
   * 更新pv_id
   * @method updatePVID
   */
  updatePVID: function updatePVID() {
    this.setConfig('pv_id', getUUID());
  },
  /**
   * 各个环境需要实现的底层埋点发送方法
   * @interface send
   * @params data {Object} 需要发送的数据
   * @params data.logs {Array} 需要发送的样本列表
   * @params data.config {Object} 全局配置
   * @private
   */
  /**
   * 发送AES埋点
   * @method log
   * @params type {String} 埋点类型
   * @params data {Object} 埋点参数
   * @params [config] {Object} 配置参数
   * @params [config.combo=true] {Boolean} 是否需要合并发送
   */
  log: function log(type) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!type) {
      return;
    }
    data.ts = data.ts || new Date().getTime();
    data.type = type;
    this._print('[AES] log', type, data);
    data = toString(data);

    // requiredField 是否已经存在
    if (isRequiredFieldNotReady(this._config)) {
      // 如果此时缓存队列超出长度限制，就不添加进队列
      if (this._reqQueue.length < MAX_REQ_QUEUE_LENGTH) {
        this._reqQueue.push([data, config.combo]);
      }
    } else {
      this._send(data, config.combo);
    }
  },
  /**
   * AOP能力，在方法执行前先执行某个方法
   * @method before
   * @params originFn {Function} 原始方法
   * @params additionalFn {Function} 需要被追加执行的方法
   */
  before: function before(originFn, additionalFn) {
    var aes = this;
    return function () {
      var args = arguments;
      var r = additionalFn.apply(aes, args);
      if (isPromise(r)) {
        r.then(function (parsedArgs) {
          originFn.apply(aes, parsedArgs || args);
        });
      } else {
        originFn.apply(aes, r || args);
      }
    };
  },
  /**
   * 在AOP能力，方法执行后执行某个方法
   * @method after
   * @params originFn {Function} 原始方法
   * @params additionalFn {Function} 需要被追加执行的方法
   */
  after: function after(originFn, additionalFn) {
    var aes = this;
    return function () {
      var args = arguments;
      originFn.apply(aes, args);
      additionalFn.apply(aes, args);
    };
  },
  /**
   * 挂载插件
   *
   *  const pluginApi = new AES().use(AESPluginAPI, {disableHookMtop: true})
   *  const [pluginApi, pluginPV] = new AES().use([AESPluginAPI, [AESPluginPV, {autoPV: false}]])
   *
   * @method use
   * @params {Function|Array} Plugins 插件原型，或者插件列表
   * @params {Object} [config] 插件配置
   */
  use: function use(Plugins, config) {
    var _this2 = this;
    // 注册多次相同插件始终返回第一次的，即同一个插件在同一个aes实例下只能挂载一次
    if (Object.prototype.toString.call(Plugins) === '[object Array]') {
      return Plugins.map(function (Plugin) {
        if (Object.prototype.toString.call(Plugin) === '[object Array]') {
          var Fun = Plugin[0];
          var _config = Plugin[1];
          return _this2._plugins[Fun] || (_this2._plugins[Fun] = new Fun(_this2, _config));
        } else {
          return _this2._plugins[Plugin] || (_this2._plugins[Plugin] = new Plugin(_this2));
        }
      });
    } else {
      return this._plugins[Plugins] || (this._plugins[Plugins] = new Plugins(this, config));
    }
  },
  /**
   * 打印log
   * @method _print
   * @private
   */
  _print: function _print() {
    if (this._config['debug'] && typeof console !== 'undefined') {
      console.log.apply(console, arguments);
    }
  },
  /**
   * 注册配置更新触发监听器
   * @param {Function} subscriber 
   */
  onConfigUpdated: function onConfigUpdated(subscriber) {
    if (this._subscribers['onConfigUpdated']) {
      this._subscribers['onConfigUpdated'].push(subscriber);
    }
  },
  _execSubscribe: function _execSubscribe(eventName, args) {
    if (this._subscribers[eventName]) {
      this._subscribers[eventName].forEach(function (subscriber) {
        subscriber.apply(this, args);
      });
    }
  }
};
export default Core;